<ng-container *ngIf="filters$ | async as filters">
  <div class="d-flex flex-column h-100">
    <div class="p-3">
      <div class="input-group mb-2 mr-sm-2">
        <input
          type="text"
          class="form-control"
          placeholder="{{ 'question_groups.filter.search' | translate }}"
          [(ngModel)]="filters.query"
          (keyup.esc)="filters.query = ''"
          (keydown.enter)="onSubmit(filters)"
        />

        <div class="input-group-append">
          <button
            type="button"
            class="btn btn-primary input-group-text"
            *ngIf="filters.query"
            (click)="filters.query = ''"
          >
            <i class="fa fa-times"></i>
          </button>
          <button
            type="button"
            class="btn btn-primary input-group-text"
            (click)="onSubmit(filters)"
          >
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </div>

    <div
      class="p-3 overflow-auto flex-grow-1"
      #scrollContainer
      (scroll)="onScroll()"
    >
      <qm-question-group-filter-advanced
        *ngIf="filters.advancedFilter as advancedFilter"
        [filter]="advancedFilter"
        [isOpen]="isOpen('advancedFilter')"
        (isOpenChange)="onOpen('advancedFilter', $event)"
        (changed)="onChangeAdvanced($event, filters)"
      ></qm-question-group-filter-advanced>
      <ng-container
        *ngFor="
          let filter of filters.simpleFilters;
          index as index;
          first as first
        "
      >
        <qm-filter-select
          *ngIf="first"
          [name]="getName(filter.category)"
          [filter]="filters.simpleFilters[index]"
          [isOpen]="isOpen(filter.category)"
          (isOpenChange)="onOpen(filter.category, $event)"
        ></qm-filter-select>

        <qm-filter-checkbox
          *ngIf="!first"
          [name]="getName(filter.category)"
          [filter]="filters.simpleFilters[index]"
          [isOpen]="isOpen(filter.category)"
          (isOpenChange)="onOpen(filter.category, $event)"
        ></qm-filter-checkbox>
      </ng-container>
    </div>

    <div class="p-3">
      <button
        class="btn btn-primary btn-block btn-lg"
        [disabled]="isDisabled() || !isDirty(filters)"
        (click)="onSubmit(filters)"
      >
        {{ 'question_groups.filter.submit' | translate }}
      </button>
      <button
        class="btn btn-secondary btn-block py-3 text-primary"
        (click)="onReset()"
      >
        {{ 'question_groups.filter.reset' | translate }}
      </button>
    </div>
  </div>
</ng-container>
